// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --line-size: 36px;
  line-height: var(--line-size);
  font-weight: var(--font-weight-medium);
  display: block;
  color: var(--color-text-primary);
  margin-top: var(--space-xl);
  margin-bottom: var(--space-lg);
}
:host[size=small] {
  font-size: var(--font-size-xl);
}
:host[size=default] {
  font-size: var(--font-heading-section-size);
}
:host[size=large] {
  font-size: var(--font-heading-section-size);
}
@media only screen and (min-width: 768px) {
  :host[size=large] {
    font-size: var(--font-heading-section-size);
  }
}
:host[color=primary] {
  color: var(--ion-color-primary);
}
:host[color=secondary] {
  color: var(--ion-color-secondary);
}
:host[color=tertiary] {
  color: var(--ion-color-tertiary);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/title/title.component.scss"],"names":[],"mappings":"AAAA;EAEI,iBAAA;EAEA,6BAAA;EACA,sCAAA;EACA,cAAA;EACA,gCAAA;EACA,2BAAA;EACA,8BAAA;AADJ;AAGI;EACI,8BAAA;AADR;AAII;EACI,2CAAA;AAFR;AAKI;EACI,2CAAA;AAHR;AAIQ;EAFJ;IAGQ,2CAAA;EADV;AACF;AAII;EACI,+BAAA;AAFR;AAKI;EACI,iCAAA;AAHR;AAMI;EACI,gCAAA;AAJR","sourcesContent":[":host {\r\n\r\n    --line-size: 36px;\r\n\r\n    line-height: var(--line-size);\r\n    font-weight: var(--font-weight-medium);\r\n    display: block;\r\n    color: var(--color-text-primary);\r\n    margin-top: var(--space-xl);\r\n    margin-bottom: var(--space-lg);\r\n\r\n    &[size='small'] {\r\n        font-size: var(--font-size-xl);\r\n    }\r\n\r\n    &[size='default'] {\r\n        font-size: var(--font-heading-section-size);\r\n    }\r\n\r\n    &[size='large'] {\r\n        font-size: var(--font-heading-section-size);\r\n        @media only screen and (min-width: 768px) {\r\n            font-size: var(--font-heading-section-size);\r\n        }\r\n    }\r\n\r\n    &[color='primary'] {\r\n        color: var(--ion-color-primary);\r\n    }\r\n\r\n    &[color='secondary'] {\r\n        color: var(--ion-color-secondary);\r\n    }\r\n\r\n    &[color='tertiary'] {\r\n        color: var(--ion-color-tertiary);\r\n    }\r\n\r\n\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
